import React from 'react';

import Header from "../Header";
import { Link, useLocation } from "react-router-dom";
import routes from "../../../../constants/Routes";
import GLOBAL from "../../../../global";
import { useTenantFeatures } from "../../../../features/tenantFeatures/useTenantFeature";

const SignInSignUpHeaderWrapper = () => {
    const location = useLocation();
    const { isAthleteEnabled } = useTenantFeatures();

    return (
        <Header>
            <div className="displayFlex flex-grow-1 justify-end align-items-center">
                {
                    [routes.signIn, routes.landing].includes(location.pathname) && !isAthleteEnabled && (
                        <div className="displayFlex">
                            <Link className={"header-signup-signin-button"} to={`${routes.signUp}${location.search}`}>
                                Sign Up
                            </Link>
                        </div>
                    )
                }

                {
                    location.pathname === routes.signUp && !(() => {
                        const params = new URLSearchParams(location.search);
                        return params.has('session_id') && params.has('pgid');
                    })() && (
                        <div className="displayFlex">
                            <Link
                                className={"header-signup-signin-button"}
                                to={{
                                    pathname: routes.signIn,
                                    search: (() => {
                                        const params = new URLSearchParams(location.search);
                                        params.set('redirect_from', 'sign_up');
                                        return params.toString();
                                    })()
                                }}
                            >
                                Sign In
                            </Link>
                        </div>
                    )
                }
            </div>
        </Header>
    )
};

export default SignInSignUpHeaderWrapper;
